module.exports = __webpack_public_path__ + "static/media/m_beard_stiletto_long__square_vector.d06f5fd6.svg";